import { render, staticRenderFns } from "./SysConfig.vue?vue&type=template&id=1d548a75&scoped=true&"
import script from "./SysConfig.vue?vue&type=script&lang=js&"
export * from "./SysConfig.vue?vue&type=script&lang=js&"
import style0 from "./SysConfig.vue?vue&type=style&index=0&id=1d548a75&lang=scss&scoped=true&"
import style1 from "./SysConfig.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d548a75",
  null
  
)

export default component.exports